import { StorageHelper } from '@smg-real-estate/hg-search-libs';

import { getAuthToken } from '@/helpers/Authentication/authClient';
import { internalAxios } from '@/helpers/http/internalAxiosClient';
import { HgLocalStorageKey } from '@/models/HgLocalStorageKey';

import { StorageNamespace } from '../storage-namespaces';

const TTL_CHECK_INTERVAL = 86400; //set expiry time is 1 day

export async function getProfileId(): Promise<string | undefined> {
  const userProfileStorageHelper = new StorageHelper(StorageNamespace.userProfile);
  const userProfileId = userProfileStorageHelper.getLocalStorageExpirableItem(
    HgLocalStorageKey.USER_PROFILE_ID,
  );

  if (userProfileId) {
    return userProfileId;
  }

  try {
    const accessToken = await getAuthToken();
    if (!accessToken) {
      return undefined;
    }

    const { data } = await internalAxios.get(import.meta.env.VUE_USER_PROFILE_API_ENDPOINT, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (data.profileId) {
      userProfileStorageHelper.setLocalStorageExpirableItem(
        HgLocalStorageKey.USER_PROFILE_ID,
        data.profileId,
        TTL_CHECK_INTERVAL,
      );
      return data.profileId;
    }

    return undefined;
  } catch (error) {
    console.error('Error fetching profile ID:', error);
    return undefined;
  }
}
